<script setup>
import FAQCell from '@/pages/faq/components/FAQCell.vue';
import FAQGroup from '@/components/common/FAQGroup.vue';

import { FAQ_ITEMS } from '@/constants/faq';

const items = [...FAQ_ITEMS]

const props = defineProps({});
</script>

<template>
  <FAQGroup title="General" bgVariant="blue">
    <template #graphic>
      <img src="@/images/utility-impostor-figure.webp" :class="s.graphic" />
    </template>
    <FAQCell
      v-for="({ title, subcontent }, index) in items"
      :key="index"
      :title="title"
      :subcontent="subcontent"
    />
  </FAQGroup>
</template>

<style module="s" lang="scss">
.graphic {
  position: relative;
}
</style>
